import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PanelControlComponent } from './panel-control.component';
import { DashboardService } from './../../dashboard/dashboard.service';

// Ngx-boostrap
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';
import {MatTooltipModule} from '@angular/material/tooltip';

import { RouterModule } from '@angular/router';
import { DashboardModule } from '../../dashboard/dashboard.module';
import { RoomComponent } from '../../dashboard/chat/room/room.component';
import { RoomService } from '../../dashboard/chat/room/room.service';
import { Ng4FilesService } from 'angular4-files-upload';
import { SocketioService } from '../../dashboard/socketio.service';
import { HttpClient, HttpHandler } from '@angular/common/http';

//Spinner
@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    FormsModule,
    NgSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    RouterModule.forChild([
        { path: '', component: PanelControlComponent }
    ])
  ],
  declarations: [
    PanelControlComponent,

  ],
  providers:[DashboardService, 
    RoomComponent,
    
  ]
})
export class PanelControlModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/panel-control/panel-control.module.ts